import React from 'react';
import styles from './BasketErrorsModal.module.scss';

const BasketErrorsSubtitle = ({ errorsCount = 0, sliderBaskets = [] }) => {
  const basketCount = sliderBaskets.length;
  const hasErrors = errorsCount > 0 && basketCount > 0;

  if (!hasErrors) {
    return null;
  }

  const basketText = basketCount === 1 ? 'basket' : 'baskets';

  return (
    <div className={styles.basketErrorsModalSubtitle}>
      {errorsCount} errors found on {basketCount} {basketText}
    </div>
  );
};

export default BasketErrorsSubtitle;
